import React from 'react'
import { Flex } from 'components/common/styles'
import SelectInput from 'components/common/Inputs/SelectInput'
import { FIELD_TRIGGER_INPUT_VALUES } from 'constants/jobsTriggers'
import {
  InputsContainer,
  InputWrapper,
  GreyText,
  Task,
} from './TriggerInputs.styles'
import messages from '../translate'
import { INPUT_TYPES, TriggerInputsProps } from './TriggerInputs.types'

const TriggerInputs = ({
  selectedInputs,
  inputs,
  formatMessage,
  onChangeFormValue,
  validationErrors,
  setValidationErrors,
}: TriggerInputsProps) => {
  const BOOLEAN_SELECT_OPTIONS = [
    { label: formatMessage(messages.yes), value: true },
    { label: formatMessage(messages.no), value: false },
    { label: formatMessage(messages.notSelected), value: null },
  ]

  const updateValidationErrors = () => {
    const newValidationErrors = { ...validationErrors }

    delete newValidationErrors[FIELD_TRIGGER_INPUT_VALUES]

    setValidationErrors(newValidationErrors)
  }

  const onChangeValue = (
    newValue: (boolean | null | string)[],
    input: number,
  ) => {
    const updatedInputs = selectedInputs.map(selectedInput =>
      selectedInput.input === input
        ? { ...selectedInput, values: newValue }
        : selectedInput,
    )

    if (!updatedInputs.find(({ values }) => values.length === 0)) {
      updateValidationErrors()
    }

    onChangeFormValue(updatedInputs, FIELD_TRIGGER_INPUT_VALUES)
  }

  return (
    <InputsContainer>
      {inputs.map(({ value, task, type, options, label }, index) => {
        const isValidationError =
          FIELD_TRIGGER_INPUT_VALUES in validationErrors &&
          selectedInputs.find(
            ({ input }) => input.toString() === value.toString(),
          )?.values.length === 0

        const selectedValue = selectedInputs.find(
          ({ input }) => input === value,
        )

        return (
          <InputWrapper
            key={`${task}-${label}-${value}`}
            align="center"
            justify="space-between">
            <Flex direction="column">
              <div>
                <GreyText>{index + 1}.</GreyText> {label}
              </div>
              <Task>{task}</Task>
            </Flex>
            {type === INPUT_TYPES.BOOLEAN && (
              <SelectInput
                label={formatMessage(messages.chooseValue)}
                options={BOOLEAN_SELECT_OPTIONS}
                value={selectedValue?.values[0]}
                onChange={(newValue: boolean | null) =>
                  onChangeValue([newValue], value)
                }
                isValidationFailed={isValidationError}
              />
            )}
            {type === INPUT_TYPES.SELECT && options && (
              <SelectInput
                isValidationFailed={isValidationError}
                hasSelectAllOption
                multiple
                label={formatMessage(messages.chooseValue)}
                options={options.map(({ value, label }) => ({
                  value,
                  label: typeof label === 'object' ? label.title : label,
                }))}
                value={selectedValue?.values}
                onChange={(newValue: string[]) =>
                  onChangeValue(newValue, value)
                }
              />
            )}
          </InputWrapper>
        )
      })}
    </InputsContainer>
  )
}

export default TriggerInputs
